import { render, staticRenderFns } from "./CobranzaCombobox.vue?vue&type=template&id=d452706c&scoped=true"
import script from "./CobranzaCombobox.vue?vue&type=script&lang=js"
export * from "./CobranzaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d452706c",
  null
  
)

export default component.exports